import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Animated, StyleSheet } from 'react-native';

import { lowerDisplayLineTestIDs, Theme } from '@constants';
import { useShowNextLDLProduct, useTodayTonightForecast } from '@hooks';

import { roundNearest5 } from '../../../helpers/DataFormatting';
import { getForecastWeatherPhrase } from '../../../helpers/getWeatherPhrase';
import { TWCAnimatedIcon } from '../../primitives/TWCAnimatedIcon/TWCAnimatedIcon';
import { TWCText } from '../../primitives/TWCText/TWCText';

const testIDPath = lowerDisplayLineTestIDs.todayTonight;
const tPath = 'lowerDisplayLine.todayTonight.';

const LDLTodayTonightAPI = () => {
  const data = useTodayTonightForecast();
  const showNextProduct = useShowNextLDLProduct();

  useEffect(() => {
    !data?.length && showNextProduct(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return data.length > 0 ? <LDLTodayTonightUI data={data[0]} onFinish={showNextProduct} /> : <></>;
};

const LDLTodayTonightUI = ({
  data: { isPast3PM, snowForecasted, daypartName, iconCodeExtend, temperature, precipChance, precipType, snowRange },
  onFinish,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    const animation = Animated.timing(new Animated.Value(0), {
      duration: 5000,
      useNativeDriver: true,
    });

    animation.start(({ finished }) => finished && onFinish?.());
    return animation.reset;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const precipChanceRounded = roundNearest5(precipChance);
  const weatherPhrase = getForecastWeatherPhrase({ iconCodeExtend });
  const precipTypeFormatted = precipType
    ? precipType[0].toUpperCase() + precipType.slice(1) // capitalize first letter
    : '';
  const precipText =
    precipChance === null || precipChance === undefined
      ? ''
      : t(`${tPath}precipText`, { precipChanceRounded, precipTypeFormatted });

  const snowRangeText = `${snowRange}" ${t(`${tPath}snowAccumulationText`)}`;

  return (
    <>
      <TWCText style={styles.productText} testID={testIDPath.productLabel} variant={'condensedText36Transparent'}>
        {daypartName ? daypartName : ''}
      </TWCText>
      <TWCAnimatedIcon code={iconCodeExtend} />
      <TWCText
        style={isPast3PM ? styles.temperatureNight : styles.itemText}
        testID={testIDPath.temperature}
        variant={'condensedText36'}
      >
        {temperature ? `${temperature}°` : ''}
      </TWCText>
      <TWCText style={styles.itemText} testID={testIDPath.weatherPhrase} variant={'condensedText36'}>
        {weatherPhrase ? weatherPhrase : ''}
      </TWCText>
      <TWCText style={styles.itemText} testID={testIDPath.precipChance} variant={'condensedText36'}>
        {snowForecasted ? snowRangeText : precipText}
      </TWCText>
    </>
  );
};

export const LDLTodayTonight = {
  API: LDLTodayTonightAPI,
  UI: LDLTodayTonightUI,
};

const styles = StyleSheet.create({
  itemText: {
    paddingLeft: Theme.px(18),
    paddingRight: Theme.px(42),
  },
  pageWrapper: {
    flexDirection: 'row',
    position: 'absolute',
  },
  productText: {
    paddingRight: Theme.px(48),
  },
  temperatureNight: {
    color: Theme.malibuBlue,
    paddingLeft: Theme.px(18),
    paddingRight: Theme.px(42),
  },
});
